import type { PermissionEnum } from 'fleet-data-model';
import UserRoleConstants from '~/constants/user-role-constants';
import type { SecureComponentRoute, SecuredRoute, SecureRedirectRoute } from './routes.types';
import { getMappedRoutes } from './routes';

interface UserPermittedRoutes {
  redirectRoutes: SecureRedirectRoute[];
  componentRoutes: SecureComponentRoute[];
}

export const newRouteAccessCheck = (
  route: SecuredRoute,
  roles: UserRoleConstants[],
  permissions: PermissionEnum[]
) => {
  if (roles.includes(UserRoleConstants.SALES_COMPANY_USER) && roles.length === 1) {
    return route.roles.includes(UserRoleConstants.SALES_COMPANY_USER);
  }
  if (route.permission) {
    // Available only if specific permission is present
    return permissions.includes(route.permission);
  }
  // Secured, but no specific permissions required
  return permissions.length > 0;
};

export const getSecuredRoutesForUserPermissions = (
  roles: UserRoleConstants[],
  permissions: PermissionEnum[]
): UserPermittedRoutes => {
  const permittedRoutes = getMappedRoutes().securedRoutes.filter((route) =>
    newRouteAccessCheck(route, roles ?? [], permissions ?? [])
  );

  return permittedRoutes.reduce<UserPermittedRoutes>(
    (acc, route) => {
      if ('redirect' in route) {
        acc.redirectRoutes.push(route);
      } else {
        acc.componentRoutes.push(route);
      }
      return acc;
    },
    {
      redirectRoutes: [],
      componentRoutes: [],
    }
  );
};
